import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography, Paper } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

/**
 * AdminRoute - gates access to admin pages.
 * Reads admin status from AuthContext (populated by /auth/verify) instead of
 * making a separate /admin/me request on every navigation.
 */
export const AdminRoute = ({ children }) => {
  const { user, token, loading } = useAuth();
  const location = useLocation();

  // Auth state still loading
  if (loading || (token && !user)) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Not authenticated - redirect to login
  if (!token || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Not an admin
  if (!user.isAdmin) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', p: 3 }}>
        <Paper sx={{ p: 4, textAlign: 'center', maxWidth: 400 }}>
          <Typography variant="h6" gutterBottom>
            Access Denied
          </Typography>
          <Typography color="text.secondary">
            You do not have permission to access the admin portal.
          </Typography>
        </Paper>
      </Box>
    );
  }

  return children;
};

export default AdminRoute;
